import { render, staticRenderFns } from "./NorwichCity.vue?vue&type=template&id=13003773&scoped=true&"
import script from "./NorwichCity.vue?vue&type=script&lang=js&"
export * from "./NorwichCity.vue?vue&type=script&lang=js&"
import style0 from "./NorwichCity.vue?vue&type=style&index=0&id=13003773&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13003773",
  null
  
)

export default component.exports